import { action } from 'easy-peasy';

import defaultTheme from '@themes/defaultTheme';
import { createTheme, Theme } from '@mui/material/styles';

import IThemeModel, { Palette } from '../types/IThemeStore';

export const constructCustomTheme = (theme: Theme, entry: Palette) => {
  const fontFamily = entry?.typography?.fontFamily || "'Inter', 'Arial', sans-serif !important";
  const customTheme: Theme = createTheme({
    ...theme,
    typography: {
      ...theme.typography,
      fontFamily,
      allVariants: {
        fontFamily
      },
      h1: { ...theme.typography.h1, fontFamily },
      h2: { ...theme.typography.h2, fontFamily },
      h3: { ...theme.typography.h3, fontFamily },
      h4: { ...theme.typography.h4, fontFamily },
      h5: { ...theme.typography.h5, fontFamily },
      h6: { ...theme.typography.h6, fontFamily },
      body1: { ...theme.typography.body1, fontFamily },
      body2: { ...theme.typography.body2, fontFamily },
      caption: { ...theme.typography.caption, fontFamily }
    },
    palette: {
      ...theme.palette,
      primary: {
        main: entry.primary,
        dark: entry.primaryDark,
        light: entry.accentColor
      },
      secondary: {
        main: entry.secondary,
        light: entry.secondary
      },
      accentColor: {
        main: entry.accentColor
      }
    }
  });
  return customTheme;
};

const themeStore: IThemeModel = {
  theme: defaultTheme,
  setTheme: action((state, entry) => {
    state.theme = constructCustomTheme(state.theme, entry);
  })
};

export default themeStore;
